import { render, staticRenderFns } from "./DropCard.vue?vue&type=template&id=0c9c95b2"
import script from "./DropCard.vue?vue&type=script&lang=js"
export * from "./DropCard.vue?vue&type=script&lang=js"
import style0 from "./DropCard.vue?vue&type=style&index=0&id=0c9c95b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports